module.exports = __webpack_public_path__ + "static/media/AB_K11_3.e2eff99f.jpg";